module.exports = __webpack_public_path__ + "img/file-type-doc-alt.8b1a94b3.svg";